import React from 'react';
import ProductCard from './ProductCard';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const ProductGrid = ({ 
  products, 
  loading, 
  error, 
  viewMode = 'grid',
  emptyMessage = 'No products found',
  emptySubMessage = 'Try adjusting your search or filters',
  onRetry
}) => {
  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <ErrorMessage 
        message={error} 
        onRetry={onRetry}
      />
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">🔍</div>
        <h3 className="text-xl font-semibold text-slateText mb-2">
          {emptyMessage}
        </h3>
        <p className="text-slateText mb-4">
          {emptySubMessage}
        </p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="bg-pinkAccent text-white px-6 py-2 rounded-lg hover:bg-pink-600 transition-colors"
          >
            Try Again
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={`grid gap-6 ${
      viewMode === 'grid' 
        ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4' 
        : 'grid-cols-1'
    }`}>
      {products.map((product) => (
        <ProductCard 
          key={product._id} 
          product={product}
          viewMode={viewMode}
        />
      ))}
    </div>
  );
};

export default ProductGrid;